"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _default;

var _react = _interopRequireDefault(require("react")),
    _utils = require("../utils");

function _default(a) {
  var b = a.isInternal,
      c = b ? "Chroma Key" : "Green Screen",
      d = "chromakey";
  return function (a) {
    var b = a.addonsCosts,
        e = a.billingEntityCode,
        f = a.includedAddons,
        g = (0, _utils.getCostForAddon)({
      billingEntityCode: e,
      costs: null
    }),
        h = f.includes("CHROMA_KEY") ? g : (0, _utils.getCostForAddon)({
      costs: b.CHROMA_KEY.costs,
      billingEntityCode: e
    });
    return [{
      reviewLabel: c,
      label: "No",
      value: !1,
      suffix: _react["default"].createElement("span", null, g),
      icon: d,
      cost: g
    }, {
      reviewLabel: c,
      label: "Yes",
      value: !0,
      suffix: _react["default"].createElement("span", null, h),
      icon: d,
      cost: h
    }];
  };
}